export const CONCLUSION_RECOMMENDATION: Record<string, string> = {
  '1': 'Huyết áp',
  '1.1': 'Huyết áp đo tại cơ sở y tế',
  '1.2': 'Huyết áp đo tại nhà',
  '2': 'Đường huyết',
  '2.1': 'Đường huyết khi đói',
  '2.2': 'Đường huyết sau 2 giờ uống',
  '2.3': 'Đường huyết HbA1c',
  '3': 'Men gan',
  '3.1': 'Chỉ số SGOT',
  '3.2': 'Chỉ số SGPT',
  '4': 'Mỡ Máu',
  '4.1': 'Chỉ số Cholesterol',
  '4.2': 'Chỉ số LDL',
  '4.3': 'Chỉ số HDL',
  '4.4': 'Chỉ số Triglyceride',
  '5': 'Ure & Creatinine',
  '5.1': 'Chỉ số Ure',
  '5.2': 'Chỉ số Creatinine',
  '6': 'Chỉ số Axit Uric',
  '7': 'Chỉ số BMI',
  '8': 'Chiều cao; Cân nặng (< 5 tuổi)',
  '8.1': 'Chỉ số Chiều dài/ Chiều cao cho bé < 5 tuổi',
  '8.2': 'Chỉ số Cân nặng cho bé < 5 tuổi',
  '8.3': 'Chỉ số Cân nặng theo Chiều dài/ Chiều cao (cho bé < 5 tuổi)',
  '9': 'Cân nặng (5 - 10 tuổi)',
  '10': 'Chiều cao ( 5 - 16 tuổi)'
};
